module.exports = __webpack_public_path__ + "static/media/SHAWL.75d46d44.svg";